<template>
  <div
    v-if="marketingCookie && (centralStoreId == currentStoreId)"
    class="c-startpage-recommendation-sponsored"
  >
    <BasicBtErrorBoundary>
      <SearchSponsoredProductList
        :store-id="currentStore"
        :current-category="undefined"
        :page-type="'HOME_PAGE'"
      >
        <template #render="{ sponsoredData, gotSponsored, onViewBeacon, error }">
          <div class="hidden">
            {{ error }}
          </div>
          <div v-show="gotSponsored">
            <div>
              <div class="flex justify-between">
                <h2 class="subtitle text-2xl font-bold text-center py-2">
                  <template
                    v-if="
                      config?.headlines
                      && config?.headlines['Gesponserte Produkte']
                      && config?.headlines['Gesponserte Produkte-Kategorien'] != ''
                    "
                  >
                    {{ config?.headlines['Gesponserte Produkte'] }}
                  </template>
                  <template v-else> Unsere gesponserten Produkte </template>
                </h2>
              </div>
            </div>
            <BasicPpm
              :slides="mapToArticleSliders(sponsoredData)"
              :view-beacon="onViewBeacon"
              list-name="Sponsored Articles PPM"
              hide-name
              is-sponsored
            />
          </div>
        </template>
      </SearchSponsoredProductList>
    </BasicBtErrorBoundary>
  </div>
</template>
<script setup lang="ts">
import { mapArticleSlideFromSponsoredArticleHit } from '~/composables/Mapper/ArticleSlide';
import type { SponsoredArticleHit } from '~~/models/AisSearch/Result';
import { validatePPMHit } from '~/composables/Ais/validator';
import { ProvideNames } from '#shared/statics';

interface StartpageConfig {
  headlines?: Record<string, string>;
}
const config = inject('startpageConfig') as StartpageConfig | undefined;

const currentStoreId = useCurrentStoreId();
const centralStoreId = ProvideNames.DEFAULT_CENTRAL_STORE.id;

const marketingCookie = getCookiePermissions(PermissionMapping.MARKETING);
const currentStore = useCurrentStore()?.value?.id;

const mapToArticleSliders = (hits: Array<SponsoredArticleHit>): Array<ArticleSlide> => {
  return hits.filter(validatePPMHit).map(mapArticleSlideFromSponsoredArticleHit);
};
</script>
<style lang="postcss">
.c-startpage-recommendation-sponsored {
  & .vueperslides__arrow {
    @apply bg-primary rounded-full w-8 h-8 bottom-full;
    & svg {
      @apply w-7 h-7 text-primary-contrast py-1.5 px-1 scale-x-110 stroke-[3px];
    }
    &.vueperslides__arrow--prev {
      @apply shadow-none left-auto right-7 top-full lg:top-[-1.5em] -translate-x-1/2 translate-y-1/2 lg:-translate-y-full;
    }
    &.vueperslides__arrow--next {
      @apply shadow-none right-5 top-full lg:top-[-1.5em] translate-x-1/2 translate-y-1/2 lg:-translate-y-full;
      & > svg {
        @apply translate-x-1;
      }
    }
  }
  & .vueperslides__bullets {
    @apply hidden;
  }
}
</style>
